import { range } from "lodash"
import * as Phaser from "phaser-ce"
import { StudentStoreSA } from "../../../react/students/StudentStoreSA"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { personalityTypeInfoMap } from "./PersonalityInfoMap"
import { PersonalityType } from "./PersonalityType"

export enum PersonalityAudio {
    INTRO = "personality-intro-1.mp3",
    INTRO_2 = "personality-intro-2.mp3",
    OUTRO = "personality-outro.mp3",
    QUIZ_RESULTS = "personality-results.mp3",
    STEP_2 = "personality-match-yourself.mp3",
    STEP_3 = "personality-conduct-interview.mp3",
    STEP_4 = "personality-finished-interview.mp3",

    // accessed with PersonalityAssets.findInterviewQuestionAudio()
    INTERVIEW_0 = "personality-question-favorite.mp3",
    INTERVIEW_1 = "personality-question-friends.mp3",
    INTERVIEW_2 = "personality-question-think.mp3",
    INTERVIEW_3 = "personality-question-try.mp3",
    INTERVIEW_4 = "personality-question-people.mp3",

    DROPDOWN = "personality-dropdown-menus.mp3",

    CLICK_NEXT = "personality-next-to-continue.mp3",
}

export enum PersonalityImage {
    OFFICE = "personality-office.png",
    LAPTOP_BLUE = "laptop-blue.png",
    LAPTOP_GREEN = "laptop-green.png",
    LAPTOP_YELLOW = "laptop-yellow.png",
    LAPTOP_YELLOW_RED = "laptop-yellow-red.png",
    QUIZ_BACKGROUND = "quiz-background.png",
    QUIZ_BACKGROUND_2 = "quiz-background2.png",
    MATCH_BACKGROUND_1 = "match-background1.png",
    STORY_BACKGROUND = "story-background.png",
    NEWS = "click-city-news.png",

    BOY = "boy.jpg",
    GIRL = "girl.jpg",
}

export enum PersonalityAtlas {
    SEARCHING = "searching.json"
}

export enum PersonalityVideo {
    INTRO_VIDEO = "personality.mp4",
}

export const loadAssets = (game: Phaser.Game) => {

    const load = PhaserUtils.makeLoader(game, "personality")

    load.autoLoad({imageEnum: PersonalityImage, audioEnum: PersonalityAudio, atlasEnum: PersonalityAtlas, videoEnum: PersonalityVideo})

    const personalityTypes: Array<PersonalityType> = Object.values(PersonalityType)
    const gender = StudentStoreSA.instance.currentGender()

    const personalityAudioLoader = (name: string, gendered?: boolean) => {
        load.audio(`personality-${name}`, `personality-${name}`, gendered)
    }
    // Quiz
    range(1, 6).forEach(x => {
        personalityAudioLoader(`quiz-${x}.mp3`)
        range(0, 5).forEach(y => {
            const letter = String.fromCharCode("a".charCodeAt(0) + y)
            personalityAudioLoader(`quiz-${x}-${letter}.mp3`)
        })
    })

    // Match
    personalityTypes.forEach(type => {
        const fileName = `match-${type}.mp3`

        const typeNumber = personalityTypeInfoMap.get(type).typeNumber
        const fileNameType = `match-type${typeNumber}.mp3`
        const fileNameTypeGender = `match-type${typeNumber}-${gender}.mp3`

        personalityAudioLoader(fileName, true)
        personalityAudioLoader(fileNameType)
        personalityAudioLoader(fileNameTypeGender)
    })

    // Interview Questions
    range(0, 6).forEach(i => {
        personalityTypes.forEach(type => {
            personalityAudioLoader(`${type}-${i}.mp3`, true)
        })
    })

    // Fill in the blank
    range(1, 5).forEach(x => {
        personalityAudioLoader(`article-title-${x}.mp3`)
    })

    range(1, 6).forEach(x => {
        range(1, 4).forEach(y => {
            personalityTypes.forEach(type => {
                const name = `fill-in-blank-${x}-${y}-${type}.mp3`
                personalityAudioLoader(name, true)
            })
        })
    })

    personalityTypes.forEach((type: PersonalityType) => {
        load.image(`personality-face-${type}-${gender}.png`, `personality-face-${type}-${gender}.png`)
    })

}

export class PersonalityAssets {

    static findQuizAudio = (questionNumber: 1 | 2 | 3 | 4 | 5, answerOption?: "a" | "b" | "c" | "d" | "e") => {
        if (answerOption) {
            return `personality-quiz-${questionNumber}-${answerOption}.mp3`
        }
        return `personality-quiz-${questionNumber}.mp3`
    }
    static findMatchResultAudio = (type: PersonalityType, description?: boolean) => {
        const typeNumber = personalityTypeInfoMap.get(type).typeNumber
        if (description) {
            // needs gender to get around too similiar naming convention
            const gender = StudentStoreSA.instance.currentGender()
            return `personality-match-type${typeNumber}-${gender}.mp3`
        }
        return `personality-match-type${typeNumber}.mp3`
    }
    static findMatchKidAudio = (type: PersonalityType) => {
        return `personality-match-${type}.mp3`
    }

    static findInterviewQuestionAudio = (num: number) => {
        return PersonalityAudio[`INTERVIEW_${num}`]
    }

    static findInterviewKidAudio = (type: PersonalityType, questionNumber: 0 | 1 | 2 | 3 | 4 | 5) => {
        return `personality-${type}-${questionNumber}.mp3`
    }

    static findFillInBlankTitleAudio = (titleOption: 1 | 2 | 3 | 4) => {
        return `personality-article-title-${titleOption}.mp3`
    }

    static findFillInBlankAudio = (blankNumber: 1 | 2 | 3 | 4 | 5, answerOption: 1 | 2 | 3, type: PersonalityType) => {
        return `personality-fill-in-blank-${blankNumber}-${answerOption}-${type}.mp3`
    }

    static findKidFace = (type: PersonalityType, gender: "boy" | "girl") => {
        return `personality-face-${type}-${gender}.png`
    }
}
